/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';
import type { TransactionsTransactionOut } from './TransactionsTransactionOut';
import {
    TransactionsTransactionOutFromJSON,
    TransactionsTransactionOutFromJSONTyped,
    TransactionsTransactionOutToJSON,
} from './TransactionsTransactionOut';

/**
 * 
 * @export
 * @interface GetChargebacksOutput
 */
export interface GetChargebacksOutput {
    /**
     * 
     * @type {TransactionsTransactionOut}
     * @memberof GetChargebacksOutput
     */
    transactions?: TransactionsTransactionOut;
    /**
     * 
     * @type {Links}
     * @memberof GetChargebacksOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof GetChargebacksOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetChargebacksOutput interface.
 */
export function instanceOfGetChargebacksOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetChargebacksOutputFromJSON(json: any): GetChargebacksOutput {
    return GetChargebacksOutputFromJSONTyped(json, false);
}

export function GetChargebacksOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChargebacksOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionOutFromJSON(json['transactions']),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetChargebacksOutputToJSON(value?: GetChargebacksOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionOutToJSON(value.transactions),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

